var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',{attrs:{"outlined":"","auto-grow":"","no-resize":"","error-messages":_vm.errors},on:{"input":function($event){return _vm.parseAndUpdate()}},model:{value:(_vm.textbox),callback:function ($$v) {_vm.textbox=$$v},expression:"textbox"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }